import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useNavigate } from "react-router-dom";
import { any, equals, join, propEq, toUpper } from "ramda";
import { notBlank } from "../../../util/ext";
import {
  buildModuleChildView,
  buildOrganizeViewPath,
  getAnthologies,
  getCollections,
  OrganizeViews,
} from "../organizeUtil";
import { useSelected } from "../OrganizeProvider";

import Avatar from "@mui/material/Avatar";
import SidebarAnthologyTreeItem from "./SidebarAnthologyTreeItem";
import SidebarCollectionTreeItem from "./SidebarCollectionTreeItem";
import SidebarTreeItem from "./SidebarTreeItem";

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 25,
    width: 25,
  },
}));

const SidebarModuleChildTreeItem = React.memo(
  function SidebarModuleChildTreeItem(props) {
    const { child, handleLabelClick } = props;

    const SidebarChild = equals(child.mediaType, "anthology")
      ? SidebarAnthologyTreeItem
      : equals(child.mediaType, "collection")
      ? SidebarCollectionTreeItem
      : SidebarTreeItem;

    return <SidebarChild handleLabelClick={handleLabelClick} {...props} />;
  },
);

const buildModuleChildNodeId = ({ module, child }) =>
  join("-", [
    OrganizeViews.ORGANIZE,
    OrganizeViews.CONTENT_GROUPS,
    OrganizeViews.MODULE,
    OrganizeViews[toUpper(child.mediaType)],
    module.id,
    child.id,
  ]);

const SidebarModuleChildrenTree = props => {
  const classes = useStyles();
  const { module, moduleChildren, showAlert } = props;
  const navigate = useNavigate();

  const {
    // removeAllSelectedCollections,
    // removeAllSelectedContent,
    removeAllSelected,
    selectedContentGroups,
    // updateSelectedAnthologies,
    // updateSelectedCollections,
    // updateActiveSelectedMediaType,
  } = useSelected();

  const handleLabelClick = ({
    // id,
    // mediaType,
    // parent,
    // prevMediaList,
    viewPath,
  }) => event => {
    // if (event.ctrlKey || event.metaKey) {
    //   if (equals(mediaType, "collection")) {
    //     updateSelectedCollections({
    //       id,
    //       parent,
    //       prevMediaList,
    //     });
    //   }

    //   if (equals(mediaType, "anthology")) {
    //     updateSelectedAnthologies({
    //       id,
    //       parent,
    //       prevMediaList,
    //     });
    //   }
    //   return;
    // }
    // removeAllSelectedContent();
    // updateActiveSelectedMediaType(mediaType);
    navigate(viewPath);
  };

  return (
    <Fragment>
      {notBlank(moduleChildren) &&
        moduleChildren.map(child => (
          <SidebarModuleChildTreeItem
            child={child}
            id={child.id}
            key={buildModuleChildNodeId({ module, child })}
            nodeId={buildModuleChildNodeId({ module, child })}
            showAlert={showAlert}
            handleLabelClick={handleLabelClick}
            onClick={() => removeAllSelected()}
            onLabelClick={handleLabelClick({
              id: child.id,
              mediaType: child.mediaType,
              parent: module,
              prevMediaList: moduleChildren,
              viewPath: buildOrganizeViewPath({
                view: buildModuleChildView(toUpper(child.mediaType)),
                ids: [module.id, child.id],
              }),
            })}
            selected={
              any(
                propEq("id", child.id),
                getCollections(selectedContentGroups),
              ) ||
              any(propEq("id", child.id), getAnthologies(selectedContentGroups))
            }
            tooltipLabel={child.name}
            label={child.name}
            parent={module}
            parentChildrenList={moduleChildren}
            icon={
              <Avatar
                classes={{ root: classes.avatar }}
                alt={`thumbnail for ${child.name}`}
                variant="rounded"
                src={child.thumbnailUrl}
              />
            }
          />
        ))}
    </Fragment>
  );
};

export default React.memo(SidebarModuleChildrenTree);
